export { firebaseAnalyticsAdapter } from '@/adapters/analytics/firebaseAnalyticsAdapter';
